import Immutable from 'immutable';

import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  status: string,
  fileUrls: Immutable.List<string>,
  folderUrl: string,
  totalFiles: number,
  copiedFiles: number
} = {
  status: '',
  fileUrls: Immutable.List(),
  folderUrl: '',
  totalFiles: 0,
  copiedFiles: 0
};

class CopyFileResult extends Immutable.Record(Content) {
  static fromJS (json: object): CopyFileResult {
    return ClassFactory.createFromJson(json, CopyFileResult);
  }

  static get Status (): { [key: string]: string } {
    return {
      OK: 'OK',
      FILES_EXIST: 'FILES_EXIST',
      CANCEL: 'CANCEL'
    };
  }
}

export default CopyFileResult;
